import {
  Component,
  computed,
  effect,
  inject,
  Input,
  Signal,
} from '@angular/core';
import { ResponseModel } from '../../generic-vaccination.model';
import { AllMaterialsStoreData } from 'src/app/modules/core/store/materials.signal.store';
import { AllMaterialModel } from 'src/app/modules/shared/models/common.model';
import { SessionVaccinationStoreData } from '../../generic-vaccination.signal.store';

@Component({
  selector: 'app-material',
  templateUrl: './material.component.html',
})
export class MaterialComponent {
  @Input() material: ResponseModel = null;
  @Input() sessionCategoryType: number = null;
  @Input() isCurrentVaccination: boolean = true;
  readonly allMaterialsStore = inject(AllMaterialsStoreData);
  readonly sessionVaccStore = inject(SessionVaccinationStoreData);
  materialInfo: Signal<AllMaterialModel> = computed(() => {
    if (this.allMaterialsStore.allMaterials()) {
      return this.allMaterialsStore
        .allMaterials()
        .find((m) => m.material_id === this.material.material_id);
    }
  });
  constructor() {}

  get materialName() {
    return this.materialInfo()?.material_name;
  }

  onMaterialChange(event) {
    if (event.checked) {
      this.sessionVaccStore.selectMaterial(this.materialInfo());
    } else {
      this.sessionVaccStore.unSelectMaterial(this.materialInfo());
    }
  }

  onSelectDose(event) {
    console.log('onSelectDose', event);
    const doseInfo = { ...event.value, vaccination_date: new Date() };
    this.sessionVaccStore.selectDose(this.materialInfo(), doseInfo);
  }

  isMaterialSelected(): boolean {
    const material = this.sessionVaccStore
      .materials()
      ?.find((m) => m.material_id === this.materialInfo().material_id);
    return !!material?.isSelected;
  }
}
